<div class="loader-container" *ngIf="showLoader">
    <div class=" loader"></div>
</div>
<jqxWindow #windVehiculoMaquinaria jqxWindowAutoResize [theme]="environment.tema" [zIndex]="900"
    [title]="translate('Vehiculos')" [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true"
    [resizable]="true" (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
    </div>
    <div class="form" style="float: left; overflow-x: hidden; width: 100%; height: 100%;">
        <jqxRibbon #movilesRibbon [theme]="environment.tema" [position]="'top'" [height]="'calc(100% - 30px)'"
            (onChange)="changeTab($event)">
            <ul>
                <li>
                    {{ translate('Resumen') }} {{resumen.totalRegistros()}}
                </li>
                <li>
                    {{ translate('Vehiculos_maquinaria')}}
                </li>
                <li>
                    GLS
                </li>
                <li>
                    {{ translate('Perifericos')}}
                </li>
                <li>
                    {{ translate('Sensores')}}
                </li>
                <li>
                    {{ translate('Software')}}
                </li>
                <li>
                    {{ translate('Total')}}
                </li>
            </ul>
            <div>
                <div>
                    <app-vehiculos-maquinaria-resumen #resumen></app-vehiculos-maquinaria-resumen>
                </div>
                <div>
                    <app-moviles-catalog></app-moviles-catalog>
                </div>
                <div>
                    <p>GLS</p>
                </div>
                <div>
                    <p>PERIFERICOS</p>
                </div>
                <div>
                    <p>SENSOSRES</p>
                </div>
                <div>
                    <p>SOFTWARE</p>
                </div>
                <div>
                    <p>TOTAL</p>
                </div>
            </div>
        </jqxRibbon>
        <div style="float: left; margin-top: 5px; display: flex; gap: 2px;">
            <jqxButton style="float: left; margin-left: 0px" [width]="100" [height]="26"
                [textImageRelation]="'imageBeforeText'" [textPosition]="'left'"
                (onClick)="windVehiculoMaquinaria.close()" [value]="translate('Salir')">
            </jqxButton>

            <jqxButton *ngIf="visualizarButtonVisible()" style="float: left" [width]="100" [height]="26"
                [imgPosition]="'left'" [textImageRelation]="'imageBeforeText'" [textPosition]="'left'"
                [imgSrc]='"/assets/images/save.png"' [value]="translate('Visualizar')" (onClick)="movilesCatalog.onGuardar()">
            </jqxButton>

        </div>
    </div>
</jqxWindow>